import React from 'react';
import { Link } from 'gatsby';
import { render,  NODE_IMAGE, NODE_PARAGRAPH, MARK_LINK } from 'storyblok-rich-text-react-renderer';
import Button from '~/components/Dynamic/Button';

export default function RichTextRenderer({ content, className='prose' }) {

  return (
    <div className={className}>
      {render(content, {
        markResolvers: {
          [MARK_LINK]: (children, props) => {
            const { href, target, linktype } = props;
            if (linktype === 'email') {
              return <a href={`mailto:${href}`}>{children}</a>;
            }
            if (href.match(/^(https?:)?\/\//)) {
              return (
                <a href={href} target={target}>
                  {children}
                </a>
              );
            }
            return (
              <Link to={href}>
                {children}
              </Link>
            );
          },
        },
        nodeResolvers: {
          [NODE_PARAGRAPH]: (children, props) => {
            return children ? <p>{children}</p> : <br/>;
          },
          [NODE_IMAGE]: (children, attrs) => {
            return <img {...attrs} className="w-full" />
          }
        }, // block elements

        blokResolvers: {
          button: (props) => <Button blok={props} />
        }, // embedded components

        defaultBlokResolver: (name, props) => (
          <div>
              <code>Missing blok resolver for blok type "{name}".</code>
              <pre><code>{JSON.stringify(props, undefined, 2)}</code></pre>
          </div>
        )
        // defaultStringResolver: (str) => (),
      })}
    </div>
  );
}
